import { render, staticRenderFns } from "./FlowPublicPage.vue?vue&type=template&id=5c9fc896&scoped=true"
import script from "./FlowPublicPage.vue?vue&type=script&lang=js"
export * from "./FlowPublicPage.vue?vue&type=script&lang=js"
import style1 from "./FlowPublicPage.vue?vue&type=style&index=1&id=5c9fc896&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9fc896",
  null
  
)

export default component.exports